import { useState } from 'react';
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';

export function PaymentForm({ onSuccess, returnUrl }: { onSuccess: () => void; returnUrl: string }) {
  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState<string | null>(null);
  const [processing, setProcessing] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    setProcessing(true);
    setError(null);

    const { error: confirmError } = await stripe.confirmPayment({
      elements,
      confirmParams: { return_url: returnUrl },
      redirect: 'if_required',
    });

    if (confirmError) {
      setError(confirmError.message || 'Zahlung fehlgeschlagen');
      setProcessing(false);
    } else {
      onSuccess();
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      {error && <p className="error" style={{ marginTop: '0.75rem' }}>{error}</p>}
      <button
        className="btn btn-primary"
        type="submit"
        disabled={processing || !stripe || !elements}
        style={{ width: '100%', marginTop: '1rem' }}
      >
        {processing ? '⏳ Verarbeite Zahlung…' : 'Jetzt bezahlen'}
      </button>
    </form>
  );
}
